import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import InsightsIcon from "@mui/icons-material/Insights";
import { PageHeader, PageShell } from "../../components/UI/Page";
import { EmptyState } from "../../components/UI/States";
import {
  getAllLeads,
  getCompletedLeads,
  getDeletedLeads,
  getLeadConvertedSale,
  getLeadCounts,
  getLeadNoContact,
} from "../Admin/Utilities/api";

const SummaryNew = () => {
  const [leads, setLeads] = useState(null);
  const [leadCounts, setLeadCounts] = useState({});
  const [completedLeads, setCompletedLeads] = useState(null);
  const [deletedLeads, setDeletedLeads] = useState(null);
  const [noContact, setNoContact] = useState(null);
  const [toSale, setToSale] = useState(null);

  useEffect(() => {
    getLeadConvertedSale(setToSale);
    getLeadNoContact(setNoContact);
    getLeadCounts(setLeadCounts);
    getAllLeads(setLeads);
    getCompletedLeads(setCompletedLeads);
    getDeletedLeads(setDeletedLeads);
  }, []);

  // Placeholder: the data above loads but nothing renders from it yet.
  return (
    <PageShell size="xl">
      <PageHeader
        icon={InsightsIcon}
        tone="emerald"
        eyebrow="Sales & Leads"
        title="Web Leads - Summary V2"
      />
      <div className="app-card rounded-2xl border">
        <EmptyState
          icon={InsightsIcon}
          title="Summary coming soon"
          description="This page doesn't show anything yet. The Web Leads page has the live counts and analytics."
          action={
            <Link to="/webleads" className="app-btn app-btn-primary">
              Open Web Leads
            </Link>
          }
        />
      </div>
    </PageShell>
  );
};

export default SummaryNew;
